var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanteGauche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280.6,
    height: 90.1,
    viewBox: "0 0 280.6 90.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #116c6f;\n      }\n\n      .cls-2 {\n        fill: #e0f4cb;\n      }\n\n      .cls-3 {\n        fill: #a0cd66;\n      }\n\n      .cls-4 {\n        fill: #209f7f;\n      }\n\n      .cls-5 {\n        fill: #c2e796;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.4,89.5c-11.6-32.5-25.8-59.4-16.1-87.3,21.8,26.8,13.2,42.7,22.2,88l-6.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.5,88.2s0,0,.1,0c.3,0,.4-.3.4-.6-4.3-23.4-8.9-42.7-12.2-56.8-2.8-11.5-4.7-19.9-5.3-25.2,0-.3-.3-.4-.5-.4-.3,0-.5.3-.4.5.6,5.4,2.6,13.7,5.4,25.3,3.4,14.1,8,33.4,12.2,56.8,0,.2.2.4.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.6,89.3c-7.8-28.4-23.5-44.1-20.8-71.5,17.7,22.3,29.3,37.1,25.8,71l-5,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225,84.6c-.3,0-.5-.2-.5-.4-2.3-22.3-13-43.5-18.7-54.9-1.4-2.8-2.5-5-3.2-6.7-.1-.2,0-.5.3-.6.2-.1.5,0,.6.3.7,1.7,1.8,3.9,3.2,6.6,3,5.9,7.1,14.1,10.8,23.6,4.3,11.3,7.1,21.9,8.1,31.6,0,.3-.2.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.1,87.9c3-21.6,8.8-46.9-5.1-85.8-10,29.7-5,47.4.1,86.3l4.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.7,86.9c-.3,0-.5-.2-.5-.4-2.4-23.7-2.8-68.6-2.6-79.7,0-.3.2-.5.5-.5.3,0,.5.2.5.5-.3,13.3.3,57.6,2.6,79.6,0,.3-.2.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.2,87c12.1-32.3,26.8-58.9,17.6-87-22.2,26.4-13.9,42.5-23.7,87.5l6.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.1,85.7s0,0-.1,0c-.3,0-.4-.3-.4-.6,4.7-23.3,9.6-42.5,13.2-56.6,3-11.5,5.1-19.8,5.8-25.1,0-.3.3-.4.5-.4.3,0,.5.3.4.5-.7,5.3-2.8,13.7-5.8,25.2-3.6,14-8.5,33.2-13.2,56.5,0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.9,78.2c-4.7-12.3-5.4-21.9,4.5-16.2,0-10.7,2.1-28.6,19.2-15.9,10.3-13.4,34.7-11.9,42.8,1,8.6-10.3,23.7-2,17,31.1h-83.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271,80.2c6.1,0,16.4-13.5,2.8-6.5,2.8-7.6,1.7-12.2-5,.4,0-5.5-1.7-12.6-7.1-.4-.9-4-2.6-10.3-4.7,0-2.5-6.3-3.5-16.8-4.7-.4-2.1-6.4-3.7-6.6-5.2,0-2.4-4.4-7.6-11.4-5.8,0-1.5-4.6-3.6-5.6-5.2-.8-1.5-3.9-2.5-10.8-4.3.8-1.6-5.4-4.5-9.1-4.5-.8-2.4-5-6.4-7.1-4.2.8-2.9-2.8-8.1-13-4.5-.8-3.2-3.1-3.9-8.1-5.8,0-1.2-4.4-4.8-9.3-6.6.9-1.3-4.9-5.2-10.2-3.1.5-3-6.3-6.9-7.8-5.5-.8-2.4-3.9-7-7.6-5.1.8-3.4-3.3-11.3-9.1-8.5.5-2.6-3.5-4.4-5.5-8.8-1.3-4.4,4.2-.3-3.8-7.5-.7-7.3,3.2-2.3-1.5-7.3.7-5,2.1-10.7-3.7-22.7-1.2-18.4,1.9-77.2,2.5-94.5,2.5-4.8-2.4-14.4-11.8-12.3-1-6.1-2.6-10.9-4.8-9.8.5-4.4-1.4-6.1-2.5-10,1.3-3.9,3.7-11.2.1-11.2,3.4s13.6,2.9,24.1,2.9,28.5-1.6,43.8.5c15.3,2,52.5-2.8,87.5-1.4,33.1,1.4,38.1-2.9,62.6-1.4,24.9,1.4,30.6.8,52.9.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanteGauche);
export default __webpack_public_path__ + "static/media/plante_gauche.143b733b027abf1f29bf4cca0b49af9b.svg";
export { ForwardRef as ReactComponent };